import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
"flex h-11 w-full rounded-tile border border-edge bg-track px-3 lg:h-9",
"font-rad text-sm text-fg outline-none transition-colors duration-200",
"file:border-0 file:bg-transparent file:text-sm file:font-medium",
"placeholder:text-faint focus:border-accent",
"disabled:cursor-not-allowed disabled:opacity-40",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
